import type { SessionWorktreeManager } from '../../worktrees/manager.js';
import { fileBrowserReadInFlight } from '../../files/browser/in-flight.js';
import { runDefinitionOp } from './handle-definition-op.js';
import { runDefinitionsOp } from './handle-definitions-op.js';
import { runReferencesOp } from './handle-references-op.js';
import { runSymbolsOp } from './handle-symbols-op.js';
import { preparedOpContext, prepareCodeNavRequest } from './prepare-code-nav-request.js';
import { normalizeCodeNavOp } from './code-nav-op-context.js';
import type { CodeNavHttpBody, CodeNavRequestMessage } from './types.js';

function indexNotReadyBody(): CodeNavHttpBody {
  return {
    indexReady: false,
    definition: null,
    definitions: [],
    references: [],
    symbols: [],
  };
}

export async function executeCodeNavRequest(
  msg: CodeNavRequestMessage,
  sessionWorktreeManager?: SessionWorktreeManager,
): Promise<CodeNavHttpBody> {
  const op = normalizeCodeNavOp(msg.op);
  if (op === 'symbols' && fileBrowserReadInFlight()) {
    return indexNotReadyBody();
  }

  const prepared = await prepareCodeNavRequest(msg, sessionWorktreeManager);
  if ('error' in prepared) return { error: prepared.error };
  if (!prepared.indexReady) return indexNotReadyBody();

  const ctx = preparedOpContext(prepared);
  switch (ctx.msg.op) {
    case 'symbols':
      return await runSymbolsOp(ctx);
    case 'references':
      return await runReferencesOp(ctx);
    case 'definitions':
      return await runDefinitionsOp(ctx);
    default:
      return await runDefinitionOp(ctx);
  }
}
